module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-view', {
    attrs: {
      "organizations": _vm.organizations,
      "viewingEvents": _vm.viewingEvents,
      "isEmptyCartPhotos": _vm.isEmptyCartPhotos
    },
    on: {
      "fetchOrganization": _vm.fetchOrganization
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2ea0150e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/subPages/MyPage/Event.vue
// module id = 688
// module chunks = 0